<template>
  <div id="app" v-cloak>
    <router-view></router-view>
    <HUD class="landscape" v-if="inSpaceship"></HUD>
    <Player class="landscape" v-if="inSpaceship"></Player>
    <transition name="fade">
      <div v-if="inSpaceship" class="landscape menu-app">
        <transition name="slide-fade">
          <GameMenu
            v-if="showGameMenu"
            :menu="menu"
            @closeMenu="switchMenu"
          ></GameMenu>
        </transition>
        <transition name="fade">
          <div
            v-if="!showGameMenu"
            class="menu-switch"
            @click="switchMenu()"
          ></div>
        </transition>
        <transition name="side-fade">
          <WanerBubble v-if="wanerMsg !== null" :msg="wanerMsg"></WanerBubble>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import GameMenu from "@/components/utilities/GameMenu";
import HUD from "@/components/utilities/HUD";
import Player from "@/components/utilities/Player";
import WanerBubble from "@/components/utilities/WanerBubble";

import AppMixin from "./AppMixin";
export default {
  name: "App",
  components: {
    GameMenu,
    HUD,
    Player,
    WanerBubble,
  },
  mixins: [AppMixin],
  data() {
    return {
      showGameMenu: false,
      menu: null,
      ratioOnce: false,
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/_variables.scss";
@import "@/assets/styles/global.scss";

[v-cloak] {
  display: none;
}

.menu-app {
  position: fixed;
  bottom: 0;
  z-index: 15;
}

.no-scrollbar {
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
